<template>

    <v-container fill-height fluid grid-list-xl>
        <v-layout justify-center wrap>
            <v-flex xs12 md12>
                <material-card
                        class="card-tabs"
                        color="green">
                    <v-flex slot="header">
                        Results summary
                    </v-flex>

                    <v-flex >
                        <div class="date-range">
                            <label for="picker">Select Dates:</label>
                            <date-range-picker
                                    id="picker"
                                    ref="picker"
                                    class="col-md-6"
                                    :opens="opens"
                                    :singleDatePicker="singleDatePicker"
                                    :timePicker="false"
                                    :showWeekNumbers="false"
                                    :showDropdowns="false"
                                    :autoApply="autoApply"
                                    v-model="dateRange"
                                    :linkedCalendars="linkedCalendars"
                                    :dateFormat="dateFormat"
                            >
                                <template v-slot:input="picker" style="min-width: 350px;">
                                    {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                                </template>
                            </date-range-picker>
                        </div>
                       <div class="small">
                           <barchart v-if="loaded" :options="options" :width="400" :height="400" :chart-data="datacollection"></barchart>
                       </div>

                    </v-flex>
                </material-card>
                <v-dialog
                        v-model="progressDialog"
                        hide-overlay
                        persistent
                        width="300"
                >
                    <v-card
                            color="primary"
                            dark
                    >
                        <v-card-text>
                            Loading Data
                            <v-progress-linear
                                    indeterminate
                                    color="white"
                                    class="mb-0"
                            ></v-progress-linear>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import barchart from "../plugins/barchart";
    import {getScanningData} from "../api/routes";
    import DateRangePicker from 'vue2-daterange-picker'
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
    import moment from 'moment'
    export default {
        name: "BarChart",
        components: {
            barchart,
            DateRangePicker
        },
        data() {
            return {
                opens: "right",
                minDate: null,
                maxDate: null,
                singleDatePicker: null,
                timePicker: null,
                timePicker24Hour: null,
                linkedCalendars: null,
                dateFormat: null,
                showWeekNumbers: null,
                showDropdowns: null,
                autoApply: true,
                dateRange: {
                    startDate: moment().startOf('month').format('MM-DD-YYYY'),
                    endDate: moment().endOf('month').format('MM-DD-YYYY')

                },
                datacollection: null,
                options: null,
                loaded: false,
                progressDialog: true,
                date: null,
            }
        },
        mounted() {
            this.options = {
                responsive: true,
                maintainAspectRatio: false,
                legends: {
                  display: true,
                  position: 'bottom'
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        },
                        stacked: false
                    }],
                    xAxes: [
                        {
                            stacked: false
                        }
                    ]
                },

            };

            this.getDashboardData()

        },
        watch: {
          dateRange: 'getDashboardData'
        },
        filters: {
            formatDate: function (date) {
                return moment(date).format("MM-DD-YYYY")
            },
        },
        methods: {

             getRandomColor() {
                var letters = '0123456789ABCDEF';
                var color = '#';
                for (var i = 0; i < 6; i++) {
                    color += letters[Math.floor(Math.random() * 16)];
                }
                return color;
            },
            getRandomInt () {
                return Math.floor(Math.random() * (50 - 5 + 1)) + 5
            },
            getDashboardData(){
                this.progressDialog = true;

                let postData = {
                    'startDate' :   moment(this.dateRange.startDate).format('YYYY-MM-DD'),
                    'endDate'   :   moment(this.dateRange.endDate).format('YYYY-MM-DD')
                };
                getScanningData(postData).then(resp => {
                    this.datacollection = {
                        labels: [ new Date()],
                        datasets: [

                        ]
                    };
                    let data = resp.data;
                    for (let i = 0; i < data.length; i++) {
                        let set = {
                            label: data[i].label,
                            backgroundColor: this.getRandomColor(),
                            data: [data[i].count],
                            borderWidth: 1
                        };
                        this.datacollection.datasets.push(set);

                    }


                }).catch(error => {
                    console.log('error', error)
                }).finally(final => {
                    this.loaded = true;
                    this.progressDialog = false;
                })
            },

        }
    }
</script>
<style>
    .small {
        max-width: 600px;
        height: 400px;
    }
    .date-range {
        max-width: 600px;
        height: 40px;
    }

</style>
